module.exports = __webpack_public_path__ + "media/flags/vi-33f8359d.svg";